import { React, useState} from 'react';
import CommonUtils from '../utils/siteUtils';
import { Container, Row, Col, Alert } from 'react-bootstrap';
import { Loading } from './Loading';
import TimedDisplay from '../components/TimedDisplay';
import '../styles/NotificationForm.css';

export default function PreviousNotifications(props) {
    const {isLoading} = props;
    const [addMsg, setAddMsg] = useState("");
    const [addMsgLevel, setAddMsgLevel] = useState("");

    const resetState = () => {
        setAddMsg("");
        setAddMsgLevel("");
    }

    const handleDelete = async(i) => {
        // prompt user to confirm DELETION of notification
        var answer = window.confirm("Are you sure you want to delete this notification?");
        if (answer) {
            var isSuccessful =  await props.onDeleteNotification(i);
            if(isSuccessful){
                setAddMsg(`Successfully deleted notification`);
                setAddMsgLevel('info');
            }
            else{
                setAddMsg(`Failed to delete notification`);
                setAddMsgLevel('danger');
            }
        } 
    }

    const handlePrevious = async(i) => {
        // prompt user to confirm UPDATING of notification
        var answer = window.confirm("Update currently displayed notification with this one?");
        if (answer) {
            var isSuccessful = await props.onNotificationUpdate(i);
            if(isSuccessful){
                setAddMsg(`Successfully updated notification`);
                setAddMsgLevel('info');
            }
            else{
                setAddMsg(`Failed to update notification`);
                setAddMsgLevel('danger');
            }
        } 
    }

    function showAlertMessage() {
        if (addMsg && addMsgLevel) {
            return (<TimedDisplay delay="3000" callback={resetState}>
                <Alert variant={addMsgLevel}>{addMsg}</Alert>
            </TimedDisplay>);
        }
        else {
            return (<></>);
        }
    }  

        return (
            !isLoading ? 
                <Container fluid>
                    <Row>
                        <Col sm={12}>
                            <h3>Previous Notifications</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            {showAlertMessage()}
                        </Col>
                    </Row>
              
                    {props.notificationList.map(notif => (
                        <Container key={notif.notificationId}  fluid className="notif-list-container">
                            <Row className="notificationLabelRow">
                                <Col xs={5}>
                                    <strong>Updated: </strong>{CommonUtils.formatDate(notif.update_Dt)}
                                </Col>
                                 <Col xs={2}>
                                    <div className={(notif.severity === "Informational") ? "notification-informational-tag notificationSevTag" : "notification-error-tag notificationSevTag"}>
                                        {(notif.severity === "Error" || notif.severity === "Alert") ? "Alert" : "Informational"}
                                    </div>
                                </Col>
                                <Col xs={5} className="notificationAudience">
                                     <strong>Audience: </strong>{notif.audience}
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12} className="notificationMessage">
                                  {notif.message}
                                </Col>
                            </Row>
                            <Row className="notificationBtnRow">
                                <Col sm={6}>
                                    <div className={(notif.enabled === true) ? "notificationEnabled" : "notificationDisabled"}>
                                        {(notif.enabled === true) ? "Currently Active" : ""}
                                    </div>
                                </Col>
                                <Col sm={6}>
                                    {!notif.enabled ? <button type="button" className="submit-button" onClick={() => { handlePrevious(notif) }}>Activate</button> : <></>}
                                     <button type="button" className="preview-button" onClick={() => { handleDelete(notif) }}>Delete</button>  
                                </Col>
                            </Row>
                        </Container>
                    ))}
                </Container>
                :
            <Loading/>
        );
}